import { Undo as Undo_kojaro } from './Undo.kojaro';
import { Undo as Undo_phosphor } from './Undo.phosphor';
import { Undo as Undo_zoomg } from './Undo.zoomg';
import { Undo as Undo_zoomit } from './Undo.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Undo_kojaro;

    case 'zoomg':
      return Undo_zoomg;

    case 'phosphor':
      return Undo_phosphor;

    default:
      return Undo_zoomit;
  }
};

export const Undo = IconRenderer();
